<template lang="html">
  <div class="question">
    <span class="question-number"> {{ index }}. </span>
    <span class="question-body" v-html="question.body"></span>
    <div class="answers-container">
      <div v-if="question.type === 'value'" class="answer-container open-answer">
        <input type="text" class="form-control vcv-input"
          :value="''"
          @change="updateValueAnswer" />
      </div>
      <answer v-for="(answer, i) in question.answers" v-else
        :key="i"
        :model="answer"
        :question-id="question.id"
        :interview="interview" />
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
import Answer from './Answer.vue';

export default {
  name: 'InterviewTestQuestion',

  components: {
    Answer
  },

  props: {
    model: Object,
    interview: Object,
    index: Number
  },

  computed: {
    question () {
      return this.model;
    }
  },

  methods: {
    updateValueAnswer (e) {
      this.$store.dispatch('interview/test/saveAnswer', {
        interview: this.interview,
        questionId: this.model.id,
        model: { body: e.target.value }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .test-container {
    width: 820px;
    font-size: 16px;
    padding-top: 21px;
    // font-family: Roboto;
    padding-bottom: 182px;
  }

  .test-title {
    text-align: center;
    padding-bottom: 34px;
  }

  .question-number {
    width: 30px;
    font-size: 24px;
    font-weight: bold;
    color: $green;
    padding-right: 18px;
  }

  .question-body {
    font-size: 18px;
  }

  .answers-container {
    flex-direction: row;
  }

  .answer-container {
    display: flex;
    width: 100%;
  }

  .answer-body {
    width: 100%;
    padding: 5px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 8px;
  }

  .answer-body_selected {
    background-color: rgb(235, 248, 233);
  }

  .open-answer:first-child {
    padding-top: 19px !important;
  }

  .answer-container:first-child {
    padding-top: 29px;
  }

  .answer-container:not(:first-child) {
    padding-top: 24px;
  }

  hr {
    padding-top: 21px;
  }

  .checkbox-area {
    width: 35px;
    padding-top: 7px;
    padding-right: 18px;
  }

  .end-video-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .end-video-text {
    padding-top: 22px;
    width: 310px;
    color: #aaa;
    font-size: 14px;
    text-align: center;
  }

  .btn-finish {
    width: 250px;
  }
</style>
